module.exports = __webpack_public_path__ + "img/abtrennung.befcea83.webp";